import client from "./client";
import type { NotiAction, RemoteNoti } from "./notifications";

export type InvitationActionCode = "join-me" | "forward" | "accept" | "reject";

const ACTION_RE =
  /^\/?follower-invitations\/(\d+)\/action\/(join-me|forward|accept|reject)$/;

export function parseInvitationAction(
  action: NotiAction,
): { id: number; code: InvitationActionCode } | null {
  const m = action.href ? ACTION_RE.exec(action.href) : null;
  if (!m) return null;
  return { id: Number(m[1]), code: m[2] as InvitationActionCode };
}

interface InvitationExtra {
  type?: string;
  root?: { id?: number } | null;
  conv?: { id?: number } | null;
}

export async function performInvitationAction(
  noti: RemoteNoti,
  action: NotiAction,
): Promise<{ code: InvitationActionCode; joinedConvId: number | null }> {
  const parsed = parseInvitationAction(action);
  if (!parsed) throw new Error("INVALID_ACTION");
  const { id, code } = parsed;
  const extra = (noti.extraInfo ?? {}) as InvitationExtra;

  if (code === "forward") {
    const rootInvitationId = extra.type === "ROOT" ? id : extra.root?.id;
    await client.post("/api/follower-invitations/create", {
      includes: [],
      excludes: [],
      parentInvitationId: id,
      rootInvitationId,
    });
    return { code, joinedConvId: null };
  }

  await client.post(`/api/follower-invitations/${id}/action/${code}`);
  const joinedConvId =
    code === "join-me" && extra.type === "ROOT" ? (extra.conv?.id ?? null) : null;
  return { code, joinedConvId };
}
